module.exports = __webpack_public_path__ + "static/media/periwinkle.d1528d20.svg";